import styled from 'styled-components';

export const CompanyInformationContainer = styled.div`
  padding: 30px 20px 0px 80px;
  flex: 1;
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
  }
`;

export const ProfileContainer = styled.div`
  width: 100%;
  max-width: 500px;
  padding: 20px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f0f0f0;
  border-radius: 5px;
  margin-bottom: 30px;
  gap: 10px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  & .mail {
    color: #8a8a8a;
  }
`;

export const CompanyInformationWrapper = styled.div`
  max-width: 500px;

  & .btn-update {
    display: flex;
    justify-content: flex-end;
  }

  & .heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  & .setting-title {
    @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
      display: none;
    }
  }
`;
